import React, { useCallback } from "react";
import { AddDocument } from "@components/documents/FinancialDocumentList/AddDocument";
import { FinancialDocumentUploadProvider } from "@components/documents/FinancialDocumentUpload/FinancialDocumentUploadProvider";
import { FinancialDocumentAttachment } from "@components/documents/FinancialDocumentAttachment/FinancialDocumentAttachment";
import styles from "./AccrualDocuments.module.scss";
import { useAccrualDocumentLinks } from "./useAccrualDocumentLinks";

interface AccrualDocumentsProps {
    financialDocumentIds?: number[];
    onLinkDocuments: (
        documentIds: number[],
        options: { onError: () => void },
    ) => void;
    onUnlinkDocuments: (
        documentIds: number[],
        options: { onError: () => void },
    ) => void;
}

export const AccrualDocuments: React.FC<AccrualDocumentsProps> = ({
    financialDocumentIds,
    onLinkDocuments,
    onUnlinkDocuments,
}) => {
    const onUnlinkDocument = useCallback(
        (documentId: number, options: { onError: () => void }) =>
            onUnlinkDocuments([documentId], options),
        [onUnlinkDocuments],
    );

    const {
        documentIds,
        attachedDocuments,
        attachDocument,
        attachDocuments,
        handleDocumentsUpload,
        detachDocument,
    } = useAccrualDocumentLinks({
        financialDocumentIds,
        onLinkDocuments,
        onUnlinkDocument,
    });

    return (
        <FinancialDocumentUploadProvider onCompleted={handleDocumentsUpload}>
            <div className={styles.container}>
                <AddDocument
                    attachDocument={attachDocument}
                    attachDocuments={attachDocuments}
                    attachedDocumentIds={documentIds}
                />
                {attachedDocuments.length > 0 && (
                    <div className={styles.attachmentList}>
                        {attachedDocuments.map((document) => (
                            <FinancialDocumentAttachment
                                key={document.id}
                                financialDocument={document}
                                detachDocument={detachDocument}
                            />
                        ))}
                    </div>
                )}
            </div>
        </FinancialDocumentUploadProvider>
    );
};
